module.exports = __webpack_public_path__ + "static/media/resultgavtres.1df4137e.png";